var _path, _path2, _path3, _path4, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6803_13095",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 2,
    width: 22,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5447 3.90909C10.5447 2.85473 9.69002 2 8.63565 2C7.58129 2 6.72656 2.85473 6.72656 3.90909V21.0909C6.72656 22.1453 7.58129 23 8.63565 23C9.69002 23 10.5447 22.1453 10.5447 21.0909V3.90909Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2694 6.77237C16.2694 5.71801 15.4146 4.86328 14.3603 4.86328C13.3059 4.86328 12.4512 5.71801 12.4512 6.77237V18.2269C12.4512 19.2813 13.3059 20.136 14.3603 20.136C15.4146 20.136 16.2694 19.2813 16.2694 18.2269V6.77237Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.0037 10.5888C22.0037 9.53442 21.149 8.67969 20.0946 8.67969C19.0403 8.67969 18.1855 9.53442 18.1855 10.5888V14.407C18.1855 15.4613 19.0403 16.3161 20.0946 16.3161C21.149 16.3161 22.0037 15.4613 22.0037 14.407V10.5888Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.81818 10.5888C4.81818 9.53442 3.96345 8.67969 2.90909 8.67969C1.85473 8.67969 1 9.53442 1 10.5888V14.407C1 15.4613 1.85473 16.3161 2.90909 16.3161C3.96345 16.3161 4.81818 15.4613 4.81818 14.407V10.5888Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6803_13095)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5306 22.9987C13.4701 22.9987 16.2892 21.8309 18.3676 19.7524C20.4462 17.6739 21.6139 14.8548 21.6139 11.9153C21.6139 8.97585 20.4462 6.15677 18.3676 4.07826C16.2892 1.99973 13.4701 0.832031 10.5306 0.832031C7.59109 0.832031 4.77202 1.99973 2.69349 4.07826C0.614969 6.15677 -0.552734 8.97585 -0.552734 11.9153C-0.552734 14.8548 0.614969 17.6739 2.69349 19.7524C4.77202 21.8309 7.59109 22.9987 10.5306 22.9987Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.59446 8.4034C6.45329 8.4034 9.5815 5.97745 9.5815 2.9849C9.5815 -0.00765061 6.45329 -2.43359 2.59446 -2.43359C-1.26437 -2.43359 -4.39258 -0.00765061 -4.39258 2.9849C-4.39258 5.97745 -1.26437 8.4034 2.59446 8.4034Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7504 24.1679C20.0795 24.1679 22.7782 19.4669 22.7782 13.6679C22.7782 7.86897 20.0795 3.16797 16.7504 3.16797C13.4214 3.16797 10.7227 7.86897 10.7227 13.6679C10.7227 19.4669 13.4214 24.1679 16.7504 24.1679Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.9626 24.35C12.6838 24.35 16.5111 21.1727 16.5111 17.2531C16.5111 13.3336 12.6838 10.1562 7.9626 10.1562C3.24137 10.1562 -0.585938 13.3336 -0.585938 17.2531C-0.585938 21.1727 3.24137 24.35 7.9626 24.35Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpower);
export default __webpack_public_path__ + "static/media/empower.ca0fc47490142dc2bc6c83066983915f.svg";
export { ForwardRef as ReactComponent };